module.exports = __webpack_public_path__ + "static/media/plus.7356f0a1.svg";